//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import {
  Card,
  CardHeader,
  CardContent,
} from '@mui/material';

// === COMPONENTS ===
import { CpuMonitor } from 'pages/ResourceMonitor/CpuMonitor';
import { MemMonitor } from 'pages/ResourceMonitor/MemMonitor';

//#endregion

//-----------------------------------------------------------------
export function SystemResourcePanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      flex      : '1 1 45%' ,
      minWidth  : '25rem'   ,
      minHeight : '19rem'   ,
      marginTop : '1rem'    ,
      padding   : '0.5rem'  ,
      borderRadius : '1rem',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
  }

  const CONTAINER = {
    sx      : _styles.container,
    variant : 'primary' ,
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Card { ...CONTAINER } >
        <CardHeader title='Resource Utilization' />
        <CardContent>
          <CpuMonitor />
          <MemMonitor />
        </CardContent>
      </Card>
    );
  };

  //#endregion

  return display();
}